import { message, theme } from 'antd';
import { useState } from 'react';
import { PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import axios from 'axios';

const useTicketsIndex = ({ initialTickets }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const [newTickets, setNewTickets] = useState(
    initialTickets.filter(({ status }) => status === 'open'),
  );
  const [inProgressTickets, setInProgressTickets] = useState(
    initialTickets.filter(({ status }) => status === 'in_progress'),
  );
  const [doneTickets, setDoneTickets] = useState(
    initialTickets.filter(({ status }) => status === 'closed'),
  );

  const [activeTicket, setActiveTicket] = useState(null);
  const [editingTicket, setEditingTicket] = useState(null);

  const handleDragStart = ({ active }) => {
    const ticketId = active.id;
    const ticket = [
      ...newTickets,
      ...inProgressTickets,
      ...doneTickets,
    ].find((t) => t.id === ticketId);

    setActiveTicket(ticket);
  };

  const handleDragEnd = ({ active, over }) => {
    if (!active || !over) return;

    const ticketId = active.id;
    const columnId = over.id;

    setNewTickets((prev) => prev.filter((ticket) => ticket.id !== ticketId));
    setInProgressTickets((prev) => prev.filter((ticket) => ticket.id !== ticketId));
    setDoneTickets((prev) => prev.filter((ticket) => ticket.id !== ticketId));

    const ticket = [
      ...newTickets,
      ...inProgressTickets,
      ...doneTickets,
    ].find((t) => t.id === ticketId);

    let newStatus = null;

    switch (columnId) {
      case 'new': {
        setNewTickets((prev) => [ticket, ...prev]);
        newStatus = 'open';

        break;
      }
      case 'in_progress': {
        setInProgressTickets((prev) => [ticket, ...prev]);
        newStatus = 'in_progress';

        break;
      }
      case 'done': {
        setDoneTickets((prev) => [ticket, ...prev]);
        newStatus = 'closed';

        break;
      }
      default:
        console.warn(`Unknown column id: ${columnId}`);
        break;
    }

    if (newStatus) {
      const csrf = document.head.querySelector("[name='csrf-token']").content;

      axios({
        headers: { 'X-CSRF-Token': csrf },
        method: 'put',
        url: `/tickets/${ticket.id}`,
        data: { status: newStatus },
      }).then((response) => {
        messageApi.success('Зміни успішно збережені');
      }).catch((error) => {
        const errorMessage =
          error?.response?.data?.errors?.join('; ') || 'Помилка при збереженні змін';
        messageApi.error(errorMessage);
        console.error(error);
      });
    }

    setActiveTicket(null);
  };

  const handleDragCancel = () => {
    setActiveTicket(null);
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const handleEditTicket = (ticket) => {
    setEditingTicket(ticket);
    setIsEditModalOpen(true);
  };

  const handleEditTicketFinish = (ticket) => {
    setEditingTicket(null);
    setIsEditModalOpen(false);

    if (ticket) {
      setNewTickets((prev) => prev.map((t) => (t.id === ticket.id ? ticket : t)));
      setInProgressTickets((prev) => prev.map((t) => (t.id === ticket.id ? ticket : t)));
      setDoneTickets((prev) => prev.map((t) => (t.id === ticket.id ? ticket : t)));
    }
  };

  const handleCreateTicket = () => {
    setIsCreateModalOpen(true);
  };

  const handleCreateTicketFinish = (ticket) => {
    setIsCreateModalOpen(false);

    if (ticket) {
      switch (ticket.status) {
        case 'open':
          setNewTickets((prev) => [ticket, ...prev]);
          break;
        case 'in_progress':
          setInProgressTickets((prev) => [ticket, ...prev]);
          break;
        case 'closed':
          setDoneTickets((prev) => [ticket, ...prev]);
          break;
        default:
          setNewTickets((prev) => [ticket, ...prev]);
          break;
      }
    }
  };

  const dndContextSensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    }),
  );

  return {
    newTickets,
    inProgressTickets,
    doneTickets,
    activeTicket,
    editingTicket,
    colorBgContainer,
    borderRadiusLG,
    isEditModalOpen,
    isCreateModalOpen,
    handleEditTicket,
    handleEditTicketFinish,
    handleCreateTicket,
    handleCreateTicketFinish,
    dndContextSensors,
    contextHolder,
    setEditingTicket,
    handleDragStart,
    handleDragEnd,
    handleDragCancel,
  };
};

export default useTicketsIndex;
